import { useEffect, useState } from 'react';
import type { SelectProps, LabeledValue } from 'core/components/ui/Select';
import { Select } from 'core/components/ui/Select';
import { filterOption } from 'core/utils';

export function CountrySelect(props: SelectProps) {
  const [options, setOptions] = useState<LabeledValue[]>([]);

  useEffect(() => {
    const getCountryList = async () => {
      const { countries } = await import('./countries');

      setOptions(countries);
    };

    getCountryList();
  }, []);

  return <Select allowClear filterOption={filterOption} options={options} showSearch {...props} />;
}
